export const generateCharacterMap = (
  selectedCharacters = [],
  charactersData = []
) => {
  const characterMap = {}

  selectedCharacters.forEach(selected => {
    const characterName = selected.current.replace(/__/g, '')
    const character = charactersData.find(char => char.name === characterName)

    if (character) {
      characterMap[selected.original] = {
        tag: character.attributes.prompting_name.replace('@', '')
      }
    }
  })

  return characterMap
}

export const createPayload = (shot, formData, videoId) => {
  const location_map = formData.locationReference || {}

  const character_map = generateCharacterMap(
    formData.selectedCharacter,
    formData.characterList
  )

  const shot_data = {
    title: shot.title,
    'initial image prompt': shot.initial_image_prompt,
    'video prompt': shot.video_prompt,
    dialogue: shot.dialogue
  }

  return {
    shot_data,
    location_map,
    character_map,
    outfit_map: formData.outfits_reference || {},
    props_map: formData.props_reference || {},
    ratio: formData.aspectRatio || '16:9',
    style:
      formData.videoStyle?.key === 'realistic'
        ? null
        : formData.videoStyle?.key || null,
    video_id: videoId
  }
}
